import { Component } from '@angular/core';

@Component({
    selector: 'atlas-style-guide-typography',
    templateUrl: './style-guide-typography.component.html',
    styleUrls: ['./style-guide-typography.component.less'],
    standalone: false
})
export class StyleGuideTypographyComponent {}
